import React, { useEffect } from 'react';
import { useSelector } from '@redux';
import { useNavigate } from 'react-router-dom';
import ForgotPassword from 'containers/ForgotPassword';

export default function ForgotPasswordPage() {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token]);

  return <ForgotPassword />;
}
